export var BOT_IDENTITY = 'lendi_bot';
export var PRIVACY_POLICY_TEXT = 'Privacy Policy';
export var BOT_FIRSTNAME_LENDI = 'Lendi';
export var BOT_FIRSTNAME_DOMAIN = 'Domain Home Loans';
export var BOT_FIRSTNAME_AUSSIE = 'Aussie';
export var PRIVACY_POLICY_LINK_LENDI = 'https://www.lendi.com.au/about-us/privacy-policy/';
export var PRIVACY_POLICY_LINK_AUSSIE = 'https://www.aussie.com.au/about-us/privacy/';
//# sourceMappingURL=constants.js.map